module.exports = __webpack_public_path__ + "img/dobozragasztas.8b67b9a8.jpg";